export const getAuthTokenFromStorage = () => localStorage.auth_token;

export const saveAuthTokenToStorage = (authToken) => localStorage.setItem('auth_token', authToken);

export const clearLocalStorage = () => delete localStorage.auth_token;

